// Generated by Melange

import * as Buhta_landing__Link from "../../../../components/html/Link.js";
import * as Buhta_landing__Route from "../../../../Route.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Cn from "../../../../../../../vendored/classnames/Cn.js";
import * as Stdlib__List from "melange/list.js";
import * as JsxRuntime from "react/jsx-runtime";

function LeftMenuItem(Props) {
  let routes = Props.routes;
  let label = Props.label;
  const currentRoute = Buhta_landing__Route.ofUrl(Buhta_landing__Route.useUrl(undefined));
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(Buhta_landing__Link.make, {
      route: Stdlib__List.hd(routes),
      className: Stdlib__List.exists((function (r) {
        return Caml_obj.caml_equal(r, currentRoute);
      }), routes) ? "paragraph-small-medium text-black-landing" : "paragraph-small text-black-landing",
      children: label
    }),
    className: Cn.fromList({
      hd: "h-6 pl-3 flex items-center mt-1 first:mt-0",
      tl: {
        hd: Stdlib__List.exists((function (r) {
          return Caml_obj.caml_equal(r, currentRoute);
        }), routes) ? "border-l-3 border-black-landing pl-2.25" : "",
        tl: /* [] */ 0
      }
    })
  });
}

const make = LeftMenuItem;

export {
  make,
}
/* Buhta_landing__Link Not a pure module */
